import LayersIcon from "@mui/icons-material/Layers";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";

interface ListStateIconFamiliarizationProps {
  approved: boolean;
}

export const ListStateIconFamiliarization = (
    props: ListStateIconFamiliarizationProps
) => (
    <ListStateIcon
        tooltip={
            props.approved
                ? Translations.FamiliarizationIsApprovedByUser
                : Translations.FamiliarizationIsNotApprovedByUser
        }
        color={props.approved ? "success" : "error"}
        icon={LayersIcon}
    />
);
